import Select from 'ol/interaction/Select';
import { pointerMove, click } from 'ol/events/condition';
import { Overlay } from 'ol';

import { getFillColorFromLayer, createSelectStyle } from './olStyles.js';
import { createElement, createMapPopup } from './htmlbuilder.js';

let overlay; // try this approach. Higher scope variable: Declare the overlay variable in a higher scope that is accessible by

export function addInteractionHover({ map, layer, events, noTooltip }) {
  var hoverInteraction = new Select({
    condition: pointerMove, // Change 'click' to 'pointerMove'
    layers: [layer],
  });

  const features = layer.getSource().getFeatures();
  const fillColor = getFillColorFromLayer(layer);
  const selectStyle = createSelectStyle(fillColor, '#00ffff');

  const overlay = new Overlay({
    element: map?.tooltip,
    positioning: 'bottom-center',
    offset: [0, -10],
  });
  map.addOverlay(overlay);

  function showTooltip(feature) {
    const coordinates = feature.getGeometry().getCoordinates();
    const info = feature.get('info');
    overlay.setPosition(coordinates);
    map.tooltipContent.innerHTML = `<strong>${info}</strong>`;
    overlay.getElement().style.display = 'block';
  }

  function addEventListeners() {
    features.forEach((feature) => {
      let id = feature.get('id');
      const row = document.getElementById(id);
      if (row) {
        row.addEventListener('click', (event) => {
          hoverInteraction.dispatchEvent({
            type: 'select',
            selected: [feature],
            isClick: true,
          });
        });
      }
    });
  }

  if (events?.hover) {
    addEventListeners();
  }

  map.addInteraction(hoverInteraction);

  let previouslyHoveredFeature = null;

  hoverInteraction.on('select', function (event) {
    var selectedFeature = event.selected[0];
    if (selectedFeature && selectedFeature.getGeometry().getType() === 'Point') {
      previouslyHoveredFeature = selectedFeature;
      selectedFeature.setStyle(selectStyle);
      features.forEach((feature) => {
        if (feature !== selectedFeature) {
          feature.setStyle(null);
        }
      });
      if (!event.isClick && !noTooltip) {
        showTooltip(selectedFeature);
      }
      if (events?.hover) {
        events.hover(event, layer, selectedFeature, event.isClick);
      }
    } else {
      overlay.getElement().style.display = 'none';
      if (previouslyHoveredFeature) {
        // Hover is off (pointer left the previously hovered feature)
        // Reset the previously hovered feature
        previouslyHoveredFeature = null;
        if (events?.hoverLeave) {
          events.hoverLeave(event);
        }
      }
    }
  });
}

export function addInteractionPopup({ map, layer, events }) {
  let popupEntries = [];
  let leftClickInteraction = new Select({
    condition: click,
    layers: [layer],
  });

  let mapContainer = document.getElementById(map.getTarget());
  let idContainer = mapContainer.id + '-' + layer.get('name');
  let popup = createMapPopup(idContainer);
  mapContainer.appendChild(popup.container);

  let popupOverlay = new Overlay({ element: popup.container });

  map.addOverlay(popupOverlay);

  map.addInteraction(leftClickInteraction);
  leftClickInteraction.on('select', function (event) {
    showPopup(event);
  });

  popup.closer.addEventListener('click', function (event) {
    event.preventDefault();
    popupOverlay.setPosition(undefined);
  });

  return popupOverlay;

  function showPopup(event) {
    var selectedFeature = event.selected[0];
    if (selectedFeature) {
      //selectedFeature.setStyle(selectStyle);

      popupEntries = [];
      popup.content.innerHTML = '';

      const cfeatures = selectedFeature.get('features');
      if (cfeatures && cfeatures.length >= 1) {
        popupEntries = cfeatures.map((f) => {
          let obj = { label: f.get('label'), feature: f };
          return obj;
        });

        popupEntries.forEach((entry) => {
          let span = createElement({
            elt: 'span',
            innerHTML: `<article><Strong>${entry.label}</Strong></article>`,
            className: [],
          });

          span.addEventListener('click', (event) => {
            events?.click?.(event, entry.feature);
          });

          popup.content.appendChild(span);
        });

        let title = 'Showing ' + popupEntries.length + ' ' + (popupEntries.length > 1 ? 'entries' : 'entry');
        popup.title.innerHTML = title;

        // Set the overlay position to the selected feature's coordinates
        const coordinate = selectedFeature.getGeometry().getCoordinates();
        popupOverlay.setPosition(coordinate);

        popup.container.style.display = 'block';
      } else {
        popupOverlay.setPosition(undefined);
      }
    } else {
      popupOverlay.setPosition(undefined);
    }
  }
}

function getPopuMinWidth(entries) {
  let minWidth = 350;

  // Function to get the length of the label property
  const getLabelLength = (entry) => {
    const label = entry.label;
    return label ? label.length : 0;
  };
  const maxLabelLength = Math.max(...entries.map(getLabelLength));

  if (maxLabelLength) {
    minWidth = maxLabelLength * 8; // 8 pixels per character
  }
  let buffer = 25;
  return minWidth + buffer + 'px';
}

export function addInteractionLineTooltip({ map, layer }) {
  // Create hover interaction for lines
  const lineHoverInteraction = new Select({
    condition: pointerMove,
    layers: [layer],
  });

  // Create tooltip overlay
  const lineTooltipOverlay = new Overlay({
    element: map?.tooltip,
    positioning: 'bottom-center',
    offset: [0, -10],
  });
  map.addOverlay(lineTooltipOverlay);

  // Handle hover events
  lineHoverInteraction.on('select', function (event) {
    const selectedFeature = event.selected[0];
    if (selectedFeature && selectedFeature.getGeometry().getType() === 'LineString') {
      const info = selectedFeature.get('info');
      if (info) {
        // Get closest point on line to mouse position for tooltip placement
        const closestPoint = selectedFeature.getGeometry().getClosestPoint(event.mapBrowserEvent.coordinate);
        lineTooltipOverlay.setPosition(closestPoint);
        map.tooltipContent.innerHTML = `<strong>${info}</strong>`;
        lineTooltipOverlay.getElement().style.display = 'block';
      }
    } else {
      // Hide tooltip when not hovering over a line
      lineTooltipOverlay.getElement().style.display = 'none';
    }
  });

  map.addInteraction(lineHoverInteraction);
  return { interaction: lineHoverInteraction, overlay: lineTooltipOverlay };
}
